import React from 'react';

const FilterField = ({ name, filters, handlers }) => (
  <th><input value={filters[name]} onChange={handlers.onFilterChange(name)} className="form-control" /></th>
);

export default FilterField;
